import React, { FC } from 'react';
import css from '../../Item/styles.module.scss';

const LoadingItem:FC = () => (
    <div className={css.loading_item}/>
    );

export default LoadingItem;